import { bool, number, oneOf, oneOfType, shape, string } from "prop-types";

import ErrorBoundary from "web/Layout/ErrorBoundary";

import Product from "./productCard";

const ProductCardContainer = ({
  product,
  isWishlistPage,
  categoryId,
  params,
  clickFrom,
  positionNumber,
  listingPosition,
  listingAmount,
  listingCategory,
  variant,
}) => {
  return (
    <ErrorBoundary>
      <Product
        product={product}
        isWishlistPage={isWishlistPage}
        categoryId={categoryId}
        clickFrom={clickFrom}
        params={params}
        positionNumber={positionNumber}
        listingPosition={listingPosition}
        listingAmount={listingAmount}
        listingCategory={listingCategory}
        variant={variant} // TODO: pass disabled if window is closed
      />
    </ErrorBoundary>
  );
};

ProductCardContainer.propTypes = {
  isWishlistPage: bool,
  product: shape({}).isRequired,
  categoryId: oneOfType([number, string, oneOf([null])]),
  clickFrom: oneOfType([string, oneOf([null])]),
  params: shape({}),
  positionNumber: number,
  listingPosition: number,
  listingAmount: number,
  listingCategory: string,
  variant: string,
};

ProductCardContainer.defaultProps = {
  isWishlistPage: false,
  categoryId: null,
  clickFrom: null,
  params: {},
  positionNumber: null,
  listingPosition: null,
  listingAmount: null,
  listingCategory: "",
  variant: "default",
};

export default ProductCardContainer;
